import { useState, useEffect } from "react";

export default function useConfig() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    async function loadConfig() {
      try {
        const res = await fetch("/config.json", { cache: "no-store" });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const allConfig = await res.json();
        const host = window.location.hostname; 
        const domainConfig = allConfig[host] || allConfig["localhost"]; // fallback

        setConfig(domainConfig);
      } catch (err) {
        console.error("Error loading config.json", err);
      }
    }
    loadConfig();
  }, []);

  return config;
}
